import React, { useEffect } from "react";
import Header from "./header";
import "../epic.css";
import generatingnote from "../images/loader.json";
import { logoutEpic } from "../../../Apimanager/Networking";
import Lottie from "react-lottie";

const defaultOptions = {
   loop: true,
   autoplay: true,
   animationData: generatingnote,
   rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
   },
};

const NotesLastStep = () => {
   useEffect(() => {
      logoutEpic();
   }, []);
   return (
      <div className="parent-epic-container-main-root">
         <div className="py-2">
            <Header
               callback={() => {}}
               startRecord={true}
               setStartRecord={() => {}}
               setShowButton={() => {}}
               showButton={false}
            />
         </div>
         <div className="card-close-callback">
            <div className="animation-container-epic-close">
               <Lottie options={defaultOptions} height={"100%"} width={"100%"} isStopped={false} isPaused={false} />
            </div>

            {/* <img src={generatingnote} alt="close-callback-icon" /> */}
            <div className="title-close-window">{"Writing SOAP Note..."}</div>
            <div className="subtitle-close-window">
               {
                  "Your note will appear in the your EPIC In-Basket in about 30 seconds Close this window at any time to be directed back to EPIC."
               }
            </div>
         </div>
      </div>
   );
};

export default NotesLastStep;
